// extracted by mini-css-extract-plugin
export default {"Section":"NDmNvaYa"};